import "./WorkflowDataCards.css";

import { Dispatch, SetStateAction } from "react";

import { OrganisationTypeConstants } from "../../../../../../constants";
import { SelectData } from "../../../../../../models";
import { useAuth } from "../../../../../../useAuth";
import { Button, CursorPagination, Select, Toggle } from "../../../../../../widget";
import { WorkflowDataCard } from "./components";
import { WorkflowDataCardModel } from "./models";

interface WorkflowDataCardsProps {
  header: string;
  data: WorkflowDataCardModel[];
  workflowTemplateUuid?: string;

  setShowCreateWorkflowTemplatePanel: Dispatch<SetStateAction<boolean>>;

  // pagination
  onPrevious: () => void;
  onNext: () => void;
  hasNext: boolean;
  hasPrevious: boolean;

  // filter
  projectTypesSelectData?: SelectData | undefined;
  projectTypeFilterUuid?: string | undefined | null;
  setProjectTypeFilterUuid?: Dispatch<SetStateAction<string | undefined | null>>;
  isExpiredFilter: boolean;
  setIsExpiredFilter: Dispatch<SetStateAction<boolean>>;
  // loading
  isLoadingWorkflowTemplates: boolean;
  isProject?: boolean;
}

export const WorkflowDataCards = ({
  data,
  workflowTemplateUuid,
  header,
  setShowCreateWorkflowTemplatePanel,
  onPrevious,
  onNext,
  hasNext,
  hasPrevious,
  projectTypesSelectData,
  projectTypeFilterUuid,
  setProjectTypeFilterUuid,
  isExpiredFilter,
  setIsExpiredFilter,
  isLoadingWorkflowTemplates,
  isProject = true,
}: WorkflowDataCardsProps): JSX.Element => {
  const { currentUserType } = useAuth();
  return (
    <div
      className={`WorkflowDataCardsContainer ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""}`}
    >
      <div className="WorkflowDataCardsHeader">
        <h2>{header}</h2>
        <div className="WorkflowDataCardsRightContainer">
          {isProject && setProjectTypeFilterUuid && (
            <>
              <h3>Filter by project type</h3>
              <Select
                value={projectTypeFilterUuid}
                data={projectTypesSelectData ?? []}
                onChange={(uuid) => setProjectTypeFilterUuid(uuid)}
              />
            </>
          )}
          {isProject && projectTypeFilterUuid && setProjectTypeFilterUuid && (
            <Button
              className="ClearFilterButton"
              text="Clear filter"
              variant="reversedPrimary"
              textUnderline
              textBold
              hasNoPadding
              size="small"
              onClick={() => setProjectTypeFilterUuid(null)}
            />
          )}
          <Toggle
            value={isExpiredFilter}
            onChange={(value) => setIsExpiredFilter(value)}
            labelAlignment="left"
            label="Show expired templates"
          />
          <Button text="New template" hasNoPadding onClick={() => setShowCreateWorkflowTemplatePanel(true)} />
        </div>
      </div>
      <div className="WorkflowDataCards">
        {data.map((dataCard) => {
          return (
            <WorkflowDataCard
              key={dataCard.uuid}
              data={dataCard}
              isActive={dataCard.uuid === workflowTemplateUuid}
              isProject={isProject}
            />
          );
        })}
      </div>
      <CursorPagination
        onPrevious={onPrevious}
        onNext={onNext}
        hasNext={hasNext}
        hasPrevious={hasPrevious}
        isLoading={isLoadingWorkflowTemplates}
      />
    </div>
  );
};
